import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import './assets/styles.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-free/css/all.css';
import '../node_modules/flowbite-vue/dist/index.css'
import HeroSection from './components/Hero.vue'
import MainNavbar from './components/Navbar.vue'
import MainComponent from './components/MainCommponent.vue'
import AboutSection from "./components/AboutSection.vue"
import ButtonGroup from './components/WorkButtons.vue'
import AboutHolePageDesign from './components/AboutHolePage.vue'
import  AboutPageHeder from './components/AboutPageHeder.vue'
import WhyuiuxParagraph  from './components/AboutPageUxSection.vue'
import 'animate.css';
import WangosProject from './components/WangosProject.vue'
import SecoundSubSection from './components/SubscriptinPtwo.vue'
import FirstProjectwrok from './components/firstProject.vue'
import AboutSliderImg from './components/AboutPolarad.vue'
import SubscriptionManagement from './components/SubscribeProject.vue'
import SubscreptionFotterSec from './components/SubscribtionFotterSec.vue'
import WangosProjectTwo from './components/WangosProjectTwo.vue'
import WangosProjectFour from './components/WangosProjectFour.vue'
import WangosProjectThree from './components/WangosProjectThree.vue'
import BakeryProject from './components/BakeryApp.vue'
import BakeryAppTwo from './components/BakeryAppTwo.vue'
import BakeryAppThree from './components/BakeryAppThree.vue'
import LorealProject from './components/LorealProject.vue'
import LorealProjectTwo from './components/LorealProjectTwo.vue'
import LorealprojectThree from './components/LorealProjectThree.vue'
import LorealProjectFour from './components/LorealProjectFour.vue'
import NextProject from './components/NextHomeProject.vue'
import NextProjectTwo from './components/NextProjectTwo.vue'
import NextProjectThree from './components/NextProjectThree.vue'


library.add(faFileArrowDown);


const routes = [
    {path:'/', component:HeroSection },
    {path:'/MainNavbar', component:MainNavbar},
    {path:'/MainComponent', component:MainComponent},
    {path:'/AboutSection', component:AboutSection},
    {path:'/ButtonGroup', component : ButtonGroup},
    {path:'/AboutHolePageDesign', component:AboutHolePageDesign},
    {path:"/AboutPageHeder" , component:AboutPageHeder},
    {path:'/WhyuiuxParagraph', component:WhyuiuxParagraph},
    {path:'/FirstProjectwork' ,  component:FirstProjectwrok , meta: { hasBackgroundImage: true }},
    {path:'/AboutSliderImg', component:AboutSliderImg},
    {path:'/SubscriptionManagement', component:SubscriptionManagement, meta: { hasBackgroundImage: true }},
    {path:'/SecoundSubSection', component:SecoundSubSection},
    {path:'/SubscreptionFotterSec', component:SubscreptionFotterSec},
    {path:'/WangosProject',component:WangosProject,meta: { hasBackgroundImage: true }},
    {path:'/WangosProjectTwo', component:WangosProjectTwo},
    {path:'/WangosProjectThree', component:WangosProjectThree},
    {path:'/WangosProjectFour', component:WangosProjectFour},
    {path:'/BakeryProject', component:BakeryProject,meta: { hasBackgroundImage: true }},
    {path:'/BakeryAppTwo', component:BakeryAppTwo},
    {path:'/BakeryAppThree', component:BakeryAppThree},
    {path:'/LorealProject', component:LorealProject,meta: { hasBackgroundImage: true }},
    {path:'/LorealProjectTwo' , component:LorealProjectTwo},
    {path:'/LorealprojectThree' , component:LorealprojectThree},
    {path:'/LorealProjectFour' , component:LorealProjectFour},
    {path:'/NextProject' , component:NextProject,meta: { hasBackgroundImage: true }},
    {path:'/NextProjectTwo' , component:NextProjectTwo},
    {path:'/NextProjectThree' , component:NextProjectThree}
    ]



const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
          return { el: to.hash, behavior: 'smooth' };
        }
        // Assuming '/MainComponent' is the path where the footer exists
        if (to.path === '/MainComponent') {
          return { el: '#footer', behavior: 'smooth' };
        }
        return savedPosition || { top: 0 };
      },
})
createApp(App).component('font-awesome-icon', FontAwesomeIcon).use(router).mount('#app')
